// BCC archive address + Copy button — shared by the lead detail "BCC to
// Pulse" row and the Externally Sent Emails tab.
import React, { useState } from "react";
import { Copy, Check } from "@phosphor-icons/react";
import { toast } from "sonner";

// "BCC to Pulse" — the lead's unique archive address with one-click copy.
// The address is built by the backend (`GET /api/crm/leads/{id}` →
// `bcc_address`) so no hostname is hardcoded here. A missing address is
// shown as an explicit, actionable error — never a bare "-" (L-3527,
// 2026-10-28: the old "Dynamic Email" row rendered "-" for every lead
// created without a token, while the tab below told users to copy it).
const BccAddressCopy = ({ address, testIdPrefix = "lead-bcc" }) => {
  const [copied, setCopied] = useState(false);
  const onCopy = async () => {
    if (!address) return;
    try {
      await navigator.clipboard.writeText(address);
      setCopied(true);
      toast.success("BCC address copied to clipboard");
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Couldn't copy — select the address and copy it manually");
    }
  };
  if (!address) {
    return (
      <span className="text-xs text-[#B91C1C]" data-testid={`${testIdPrefix}-unavailable`}>
        BCC archive address unavailable — refresh the page; if it persists, contact a platform admin.
      </span>
    );
  }
  return (
    <span className="flex items-center gap-2 min-w-0">
      <code className="text-xs font-mono break-all select-all" data-testid={`${testIdPrefix}-address`}>{address}</code>
      <button
        type="button"
        onClick={onCopy}
        className="inline-flex items-center gap-1 px-1.5 py-0.5 text-[11px] text-[#525252] hover:text-[#0055FF] border border-[#E5E5E5] hover:border-[#0055FF] rounded-none flex-shrink-0"
        title="Copy this lead's BCC archive address"
        aria-label="Copy BCC archive address"
        data-testid={`${testIdPrefix}-copy-btn`}
      >
        {copied ? <><Check size={11} weight="bold" /> Copied</> : <><Copy size={11} /> Copy</>}
      </button>
    </span>
  );
};

export default BccAddressCopy;
